import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { MotifTabNavigation, MotifTabControl } from '@ey-xd/motif-react';
import { Link, Navigate } from 'react-router';
import { reduxForm, reset, SubmissionError } from 'redux-form';
import { withRouter } from '../../common/withRouter';
import MasterDataManagementSecuritiesHeader from '../../components/masterDataManagement/MasterDataManagementSecuritiesHeader';
import SecurityComponent from '../../components/masterDataManagement/Securities/SecurityComponent';
import CreateEditSecurityModal from '../../components/masterDataManagement/Securities/CreateEditSecurityModal';
import * as dateHelpers from '../../scripts/dateHelpers';
import * as reitActions from '../../actions/reitActions';
import * as masterDataManagementActions from '../../actions/masterDataManagementActions';
import * as commonActions from '../../actions/commonActions';
import UploadSecuritiesModal from '../../components/masterDataManagement/Securities/UploadSecuritiesModal';
/**
 * MasterDataManagementSecuritiesContainer component
 * @extends {React.Component}
 */
class MasterDataManagementSecuritiesContainer extends Component {
  /**
   * Creates a new MasterDataManagementSecuritiesContainer
   * @constructor
   * @param {Object} props The component properties
   * @param {Object} context The component context
   */
  constructor(props, context) {
    super(props, context);
    this.state = {
      tabBar1: 0,
      securityMasterData: [],
      gridCurrentState: [],
      gridColumnState: [],
      refreshGridSecurityData: {
        refreshGridOnCompletedAction: -1,
      },
      showAddSecurityModal: false,
      addSecurityModalHeader: '',
      showSecurityForm: false,
      securityFormPurpose: '',
      initialValues: null,
      securityFormInitialValues: null,
      selectedSecurity: {
        clientID: props.clientId,
        securitiesMasterID: 0,
        securityName: '',
        issuer: '',
        class: '',
        isSystemGenerated: false,
        chartName: '',
        subAttribute: '',
        reitid: 0,
        propertyMasterID: 0,
        acquisitionDate: '',
        endDate: '',
        reitSuiteEntityIDForProperty: null,
        reitSuiteEntityIDForREIT: null,
      },
      hideSecuritySuccessMessage: false,
      showSecuritySuccess: false,
      showEditSecurityRowDataModal: false,
      showDeleteSecurityConfirmationModal: false,
      showUploadSecuritiesModal: false,
    };
    this.handleGridChanges = this.handleGridChanges.bind(this);
    this.showSecurityForm = this.showSecurityForm.bind(this);
    this.handleCloseSecurityForm = this.handleCloseSecurityForm.bind(this);
    this.handleSecuritySubmit = this.handleSecuritySubmit.bind(this);
    this.handleSecurityCreateSubmit =
      this.handleSecurityCreateSubmit.bind(this);
    this.handleSecurityEditSubmit = this.handleSecurityEditSubmit.bind(this);
    this.handleEditButtonClick = this.handleEditButtonClick.bind(this);
    this.handleDismissSecurityErrorMessage =
      this.handleDismissSecurityErrorMessage.bind(this);
    this.handleConfirmButtonClick = this.handleConfirmButtonClick.bind(this);
    this.toggleShowDeleteSecurityConfirmationModal =
      this.toggleShowDeleteSecurityConfirmationModal.bind(this);
    this.handleDownloadMasterDataReport =
      this.handleDownloadMasterDataReport.bind(this);
    this.toggleShowEditSecurityRowDataModal =
      this.toggleShowEditSecurityRowDataModal.bind(this);
    this.clearValidationMessage = this.clearValidationMessage.bind(this);
    this.handleExportSecuritiesImportTemplate =
      this.handleExportSecuritiesImportTemplate.bind(this);
    this.handleUploadSecuritiesImportTemplate =
      this.handleUploadSecuritiesImportTemplate.bind(this);
    this.toggleUploadSecuritiesModal =
      this.toggleUploadSecuritiesModal.bind(this);
  }

  /**
   * Invoked immediately after mounting occurs
   * @returns {undefined}
   */
  componentDidMount() {
    if (this.props.clientId) {
      this.props.reitActions.fetchReits(this.props.clientId, true);
      this.fetchSecuritiesData(this.props.clientId);
    }
    this.resetGridColumnState();
  }
  componentDidUpdate(prevProps) {
    if (this.props.clientId !== prevProps.clientId) {
      this.props.reitActions.fetchReits(this.props.clientId, true);
      this.fetchSecuritiesData(this.props.clientId);
    }
    if (
      this.props.securityMasterData &&
      this.props.securityMasterData !== prevProps.securityMasterData
    ) {
      this.setState({ securityMasterData: this.props.securityMasterData });
    }
  }

  componentWillUnmount() {}

  fetchSecuritiesData() {
    const { clientId } = this.props;
    if (clientId) {
      this.props.masterDataManagementActions.fetchSecurityMasterData(clientId);
    }
  }

  showSecurityForm(e) {
    e.preventDefault();
    const selectedSecurity = {
      clientID: this.props.clientId,
      securitiesMasterID: 0,
      securityName: '',
      issuer: '',
      class: '',
      isSystemGenerated: false,
      subAttribute: '',
      reitid: 0,
      propertyMasterID: 0,
      acquisitionDate: '',
      endDate: '',
    };
    let securityFormInitialValues = Object.assign({}, selectedSecurity);
    this.setState({
      showSecurityForm: true,
      securityFormPurpose: '',
      selectedReit: selectedSecurity,
      securityFormInitialValues: securityFormInitialValues,
      validationMessage: '',
    });
  }
  handleEditButtonClick = (values) => {
    this.clearValidationMessage();
    if (values) {
      const Security = {
        clientID: this.props.clientId,
        securitiesMasterID: values.securitiesMasterID,
        securityName: values.securityName,
        issuer: values.issuer,
        class: values.class,
        isSystemGenerated: values.isSystemGenerated,
        reitStatus: values.isActive,
        reitName: values.reitShortName,
        propertyName: values.propertyName,
        chartName: values.chartName,
        subAttribute: values.subAttribute,
        reitid: values.reitid,
        propertyMasterID: values.propertyMasterID,
        acquisitionDate: values.acquisitionDate,
        endDate: values.endDate,
        reitSuiteEntityIDForProperty: values.reitSuiteEntityIDForProperty,
        reitSuiteEntityIDForREIT: values.reitSuiteEntityIDForREIT,
      };

      let initialValues = Object.assign({}, Security);
      this.setState({
        showSecurityForm: true,
        securityFormPurpose: 'EDIT',
        selectedSecurity: Security,
        securityFormInitialValues: initialValues,
      });
    }
  };

  toggleShowEditSecurityRowDataModal() {
    this.setState({
      showSecurityForm: !this.state.showSecurityForm,
    });
  }

  handleDownloadMasterDataReport() {
    this.props.masterDataManagementActions.exportAllTypesData(
      this.props.clientId
    );
  }

  handleEditSecurityClick = (values) => {
    this.clearValidationMessage();
  };
  handleSecurityEditSubmit(values) {
    this.props.commonActions.beginTask();
    this.setState({ showSecuritySuccess: false });
    const Security = {
      ClientID: this.props.clientId,
      SecuritiesMasterID: values.securitiesMasterID,
      SecurityName: values.securityName,
      Issuer: values.issuer,
      Class: values.class,
      IsSystemGenerated: values.isSystemGenerated,
      SubAttribute: values.subAttribute,
      REITID: values.reitid,
      PropertyMasterID: values.propertyMasterID,
      SecurityAcquisitionDate: values.acquisitionDate,
      SecurityEndDate: values.endDate,
    };

    return this.updateSecurity(Security);
  }

  updateSecurity(Security) {
    return masterDataManagementActions
      .updateSecurity(Security)
      .then((response) => {
        if (response && response.success) {
          this.handleCloseSecurityForm();
          this.props.commonActions.endTask();
          this.fetchSecuritiesData(this.props.clientId);
          this.refreshGrid();
          this.setState({ validationMessage: '' });
        } else if (response && response.errorMessage) {
          this.props.commonActions.endTask();

          if (
            response.errorMessage ===
            'The given Security Name, Issuer and Class already exist in the system for the REIT.'
          ) {
            this.setState({
              validationMessage:
                'Security Name, Issuer and Class already exist within the REIT.',
            });
          } else if (
            response.errorMessage.includes('Acquisition Date must be in')
          ) {
            this.setState({ validationMessage: response.errorMessage });
          } else if (response.errorMessage.includes('End Date must be in')) {
            this.setState({ validationMessage: response.errorMessage });
          } else if (response.errorMessage.includes('End Date must be after')) {
            this.setState({ validationMessage: response.errorMessage });
          } else {
            // For any other error messages
            this.setState({
              errorMessage: response.errorMessage,
              validationMessage: response.errorMessage,
            });
          }
        }
      })
      .catch((error) => {
        this.props.commonActions.endTask();
        this.setState({
          errorMessage: 'An error occurred while updating the security.',
        });
      });
  }

  handleDeleteButtonClick = (values) => {
    this.clearValidationMessage();
    if (values) {
      const security = {
        securitiesMasterID: values.securitiesMasterID,
        securityName: values.securityName,
        reitid: values.reitid,
      };

      let securityFormInitialValues = Object.assign({}, security);
      this.setState({
        showDeleteSecurityConfirmationModal: true,
        selectedSecurity: security,
        securityFormInitialValues: securityFormInitialValues,
      });
    }
  };
  handleDismissSecurityErrorMessage() {
    this.props.commonActions.clearFormErrors('editSecurityForm');
  }
  handleCloseSecurityForm() {
    this.setState({ showSecurityForm: false });
  }

  handleSecuritySubmit(values, e) {
    this.setState({ hideSecuritySuccessMessage: false });

    const acquisitionDate = values.acquisitionDate;
    const endDate = values.endDate;

    if (acquisitionDate && endDate) {
      const acquisitionDateObj = new Date(acquisitionDate);
      const endDateObj = new Date(endDate);

      if (endDateObj < acquisitionDateObj) {
        this.setState({
          validationMessage:
            'The End Date cannot be earlier than the Acquisition Date.',
        });
        return;
      }
    }

    let SecurityToHandle = Object.assign({}, values);
    if (values.ein && values.ein.indexOf('-') === -1) {
      SecurityToHandle.ein = `${values.ein.slice(0, 2)}-${values.ein.slice(2)}`;
    }
    if (this.state.securityFormPurpose === 'EDIT') {
      return this.handleSecurityEditSubmit(SecurityToHandle);
    }
    return this.handleSecurityCreateSubmit(SecurityToHandle);
  }
  clearValidationMessage() {
    if (this.state.validationMessage != '') {
      this.setState({ validationMessage: '' });
    }
  }
  handleSecurityCreateSubmit(values) {
    this.props.commonActions.beginTask();

    this.setState({ showSecuritySuccess: false });

    const Security = {
      ClientID: this.props.clientId,
      SecuritiesMasterID: 0,
      SecurityName: values.securityName,
      Issuer: values.issuer,
      Class: values.class,
      IsSystemGenerated: false, // This should be false for user-created securities
      SubAttribute: '',
      REITID: values.reitid,
      PropertyMasterID: 0,
      SecurityAcquisitionDate: values.acquisitionDate,
      SecurityEndDate: values.endDate,
      ChartID: values.chartID,
    };
    //Create Security
    this.props.masterDataManagementActions
      .createSecurity(Security)
      .then((response) => {
        if (response && response.success) {
          this.props.masterDataManagementActions.fetchSecurityMasterData(
            this.props.clientId
          );
          this.setState({ showSecurityForm: !this.state.showSecurityForm });
          this.props.commonActions.endTask();
          this.props.dispatch(reset('EditSecurityForm'));
          this.setState({ validationMessage: '' });
        } else if (response && response.errorMessage) {
          this.props.commonActions.endTask();

          // Handle specific error messages
          if (
            response.errorMessage ===
            'The given Security Name, Issuer and Class already exist in the system for the REIT.'
          ) {
            this.setState({
              validationMessage:
                'Security Name, Issuer and Class already exist within the REIT.',
            });
          } else if (response.errorMessage.includes('End Date must be after')) {
            this.setState({ validationMessage: response.errorMessage });
          } else {
            // For any other error message
            this.setState({
              errorMessage: response.errorMessage,
              validationMessage: response.errorMessage,
            });
          }
        }
      })
      .catch((error) => {
        this.props.commonActions.endTask();
        this.setState({
          errorMessage: 'An error occurred while creating the security.',
        });
      });
  }
  handleConfirmButtonClick = (values) => {
    if (values) {
      this.props.masterDataManagementActions
        .deleteSecurity(
          this.props.clientId,
          this.state.selectedSecurity.reitid,
          this.state.selectedSecurity.securitiesMasterID
        )
        .then((response) => {
          if (response && response.success) {
            this.setState({
              showDeleteSecurityConfirmationModal: false,
              selectedSecurity: null,
              apiErrorMessage: '', // Clear any previous error message
            });
            this.fetchSecuritiesData(this.props.clientId);
          } else if (
            response &&
            response.errorMessage &&
            response.errorMessage.includes(
              'The Security cannot be deleted because it may have a REIT Owned Shares Value or All Shares from Issuer Value or Percent of Vote within the REIT Period. The earliest period this condition exists is in'
            )
          ) {
            this.setState({ validationMessage: response.errorMessage });
            this.props.commonActions.endTask();
          } else {
            this.setState({
              apiErrorMessage:
                response.errorMessage ||
                'An error occurred while deleting the security.',
            });
          }
        })
        .catch((error) => {
          this.setState({
            apiErrorMessage: error.message || 'An unexpected error occurred.',
          });
        });
    }
  };
  toggleShowDeleteSecurityConfirmationModal() {
    this.setState({
      showDeleteSecurityConfirmationModal:
        !this.state.showDeleteSecurityConfirmationModal,
    });
  }
  //Set tab related state variables
  setActiveTab(currentIndex) {
    this.setState({ tabBar1: currentIndex });
  }

  //Set current tab index based
  handleTabClick(index) {
    this.setActiveTab(index);
  }
  handleGridChanges(gridRowData) {
    let rowData = [];
    rowData =
      gridRowData &&
      gridRowData.length &&
      gridRowData.map((x) => {
        return {
          SecuritiesMasterID: x.securitiesMasterID,
          SecurityName: x.securityName,
          Issuer: x.issuer,
          Class: x.class,
          IsSystemGenerated: x.isSystemGenerated,
          InitialQuarter: x.initialQuarter,
          FinalQuarter: x.finalQuarter,
          SubAttribute: x.subAttribute,
          REITSuiteEntityIDforREIT: x.reitSuiteEntityIDForREIT,
          REITSuiteEntityIDforProperty: x.reitSuiteEntityIDForProperty,
          AcquisitionDate: x.acquisitionDate,
          EndDate: x.endDate,
        };
      });
    this.setState({ gridCurrentState: rowData });
  }
  setGridColumnState() {
    let columnState = localStorage.getItem(
      'REITSuiteSecuritiesDataColumnState'
    );
    if (columnState) {
      this.setState({ gridColumnState: JSON.parse(columnState) });
    } else {
      this.setState({ gridColumnState: [{ colId: '-1' }] });
    }
  }
  resetGridColumnState() {
    localStorage.removeItem('REITSuiteSecuritiesDataColumnState');
  }
  handleGridColumnStateChange(columnState) {
    this.setState({ gridColumnState: columnState });
  }
  refreshGrid(selectedData = []) {
    const randomNumber = parseInt(Math.random() * (99999999 - 1)) + 1;
    if (
      selectedData &&
      Array.isArray(selectedData) &&
      selectedData.length > 0
    ) {
      this.setState({
        refreshGridSecurityData: {
          refreshGridOnCompletedAction: randomNumber,
        },
      });
    } else {
      this.setState({
        refreshGridSecurityData: {
          refreshGridOnCompletedAction: randomNumber,
        },
      });
    }
  }
  handleExportSecuritiesImportTemplate() {
    this.props.masterDataManagementActions.exportSecuritiesData(
      this.props.clientId
    );
  }
  handleUploadSecuritiesImportTemplate() {
    // Implement upload template functionality
    this.setState({ showUploadSecuritiesModal: true });
  }

  toggleUploadSecuritiesModal(clientID) {
    this.setState({
      showUploadSecuritiesModal: !this.state.showUploadSecuritiesModal,
    });
    if (clientID && clientID === this.props.clientId) {
      this.fetchSecuritiesData(this.props.clientId);
    }
  }

  render() {
    if (this.props.isAudit) {
      return (
        <Navigate to={`/client/${this.props.clientId}/masterDataManagement`} />
      );
    }

    return (
      <div>
        <h2 data-testid="pghdrMasterDataManagement">Master Data Management</h2>
        <MotifTabNavigation variant="default">
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/groups`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(1)}
              data-testid="tbGroups"
            >
              Groups
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/reits`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(2)}
              data-testid="tbREITs"
            >
              REITs
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/properties`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(3)}
              data-testid="tbProperties"
            >
              Properties
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/securities`}
            tabIndex="-1"
            hidden={this.props.isAudit}
          >
            <MotifTabControl
              className="motif-active"
              role="tab"
              onClick={() => this.handleTabClick(4)}
              data-testid="tbSecurities"
            >
              Securities
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/trs`}
            tabIndex="-1"
            hidden={this.props.isAudit}
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(5)}
              data-testid="tbTrs"
            >
              Taxable REIT Subsidiaries
            </MotifTabControl>
          </Link>
        </MotifTabNavigation>
        <MasterDataManagementSecuritiesHeader
          handleAddSecurity={this.showSecurityForm}
          handleExportSecurityImportTemplate={
            this.handleExportSecuritiesImportTemplate
          }
          handleUploadSecurityImportTemplate={
            this.handleUploadSecuritiesImportTemplate
          }
          handleDownloadMasterDataReport={this.handleDownloadMasterDataReport}
        />

        {this.state.showUploadSecuritiesModal && (
          <UploadSecuritiesModal
            show={this.state.showUploadSecuritiesModal}
            onClose={this.toggleUploadSecuritiesModal}
          />
        )}

        <CreateEditSecurityModal
          isOpen={this.state.showSecurityForm}
          securityFormPurpose={this.state.securityFormPurpose}
          handleSubmit={this.handleSecuritySubmit}
          initialValues={this.state.securityFormInitialValues}
          handleDismissErrorMessage={this.handleDismissSecurityErrorMessage}
          isAudit={this.props.isAudit}
          handleCloseSecurityForm={this.handleCloseSecurityForm}
          reits={this.props.reits}
          validationMessage={this.state.validationMessage}
          clearValidationMessage={this.clearValidationMessage}
        />

        <SecurityComponent
          securitiesData={this.props.securityMasterData}
          handleGridChanges={this.handleGridChanges}
          gridColumnState={this.gridColumnState}
          handleGridColumnStateChange={this.handleGridColumnStateChange}
          refreshGridSecurityData={this.refreshGridSecurityData}
          handleEditButtonClick={this.handleEditButtonClick}
          handleDeleteButtonClick={this.handleDeleteButtonClick}
          handleConfirmButtonClick={this.handleConfirmButtonClick}
          showDeleteSecurityConfirmationModal={
            this.state.showDeleteSecurityConfirmationModal
          }
          toggleShowDeleteSecurityConfirmationModal={
            this.toggleShowDeleteSecurityConfirmationModal
          }
          validationMessage={this.state.validationMessage}
          clearValidationMessage={this.clearValidationMessage}
          selectedSecurity={this.state.selectedSecurity}
          handleDismissErrorMessage={this.handleDismissSecurityErrorMessage}
        />
      </div>
    );
  }
}

MasterDataManagementSecuritiesContainer.propTypes = {
  clientId: PropTypes.number,
  isAudit: PropTypes.bool,
  securityMasterData: PropTypes.array,
  dispatch: PropTypes.func,
  reitActions: PropTypes.object,
  commonActions: PropTypes.object,
  reits: PropTypes.array,
  masterDataManagementActions: PropTypes.object,
};

/**
 * Maps items from state to properties of the component
 * @param {Object} state The state
 * @returns {Object} An object containing properties that the component can access
 */
function mapStateToProps(state, ownProps) {
  let cid = Number.parseInt(ownProps.router.params.clientId);
  if (isNaN(cid)) {
    cid = 0;
  }

  return {
    clientId: cid,
    isAudit: state.client && state.client.isAudit,
    securityMasterData: state.securityMasterData,
    reits: state.reits,
  };
}

/**
 * Binds actions to the dispatcher
 * @param {Object} dispatch The action dispatcher
 * @returns {Object} An object containing properties that the component can access
 */
function mapDispatchToProps(dispatch) {
  return {
    reitActions: bindActionCreators(reitActions, dispatch),
    masterDataManagementActions: bindActionCreators(
      masterDataManagementActions,
      dispatch
    ),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    reduxForm({
      form: 'masterDataManagementSecuritiesForm',
      enableReinitialize: true,
    })(MasterDataManagementSecuritiesContainer)
  )
);
